<template>
	<div
		class="d-flex flex-column gap-2 align-center"
		:class="isXS ? 'height-full justify-center' : ''"
	>
		<Skeleton class="icon-skeleton rounded-4" />
		<Skeleton class="title-skeleton rounded-2" />
		<Skeleton class="description-skeleton rounded-2" />
	</div>
	<Skeleton class="button-loader rounded-2 mt-6" />
</template>
<script setup lang="ts">
	interface Props {
		isXS: boolean
	}
	defineProps<Props>()
</script>
<style lang="scss" scoped>
	.icon-skeleton {
		width: 54px;
		height: 54px;
	}
	.title-skeleton {
		width: 33%;
		height: 24px;
	}
	.description-skeleton {
		width: 66%;
		height: 24px;
	}
	.button-loader {
		width: 100%;
		height: 48px;
	}
</style>
